import { isInternalRole } from "./permissions";

/** A supported role permits admin opt-in; it never grants Credit Key access. */
export function isCreditKeyPurchaserRole(role?: string | null): boolean {
  return role?.toLowerCase() === "customer" || isInternalRole(role);
}
